import React from 'react'
import styles from "./button.module.css";

const Button = (props) => {

    return (

        <div onClick={props.onClick} className={styles.container}>
            <p>{props.children || "Button"}</p>
        </div>
    )
}

export default Button